import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { ScheduleBlockContainer, ScheduleTime, ScheduleBlock } from './styles';
import { useSelectBlock } from './use-select-block.hook';
import { ScheduleSelectBlockProps } from '../interface';

export const ScheduleSelectBlock = ({
  time,
  available,
  formatTime,
  addRef,
  listRefs,
  top,
  setIsScrollToSelectedValue,
  durations,
  defaultOffsetTop,
  resourceName,
}: ScheduleSelectBlockProps): JSX.Element => {
  const intl = useIntl();
  const { handleBlockClick, ref } = useSelectBlock({
    addRef,
    listRefs,
    available,
    formatTime,
    time,
    top,
    setIsScrollToSelectedValue,
    durations,
    defaultOffsetTop,
  });

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent<HTMLDivElement>) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        handleBlockClick();
      }
    },
    [handleBlockClick],
  );

  const formattedTime = formatTime(time);

  return (
    <ScheduleBlockContainer ref={ref}>
      <ScheduleTime aria-hidden="true">{formattedTime}</ScheduleTime>
      <ScheduleBlock
        onClick={handleBlockClick}
        onKeyDown={handleKeyDown}
        role="button"
        tabIndex={available ? 0 : -1}
        aria-disabled={!available}
        aria-label={
          resourceName
            ? intl.formatMessage({ id: 'time_slot_label' }, { resourceName, time: formattedTime })
            : formattedTime
        }
        className="schedule-block"
        data-testid="schedule-block"
        isAvailable={available}
      />
    </ScheduleBlockContainer>
  );
};
